import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
  address: yup.string().label('Address').min(2, 'Address should be at least 2 symbols'),
});

export default schema;
